module.exports = __webpack_public_path__ + "media/85.956f7eb2.mp3";